export default "__VITE_ASSET__DXaEPyEM__"